module.exports = __webpack_public_path__ + "img/login-check-ok.51e7a3b7.svg";